import React from "react";
import PaymentBankDuyetPage from "./payment-bank-duyet-page";
import PaymentMomoDuyetPage from "./payment-momo-duyet-page";


export default function PaymentDuyetPage() {

  return <div>
    <PaymentBankDuyetPage/>
    <div className="h-10 bg-[#eef0f3]"/>
    <PaymentMomoDuyetPage/>
  </div>;
}
